<img [src]="source"
     target="_blank"
     (click)="editImage($event)"
     class="img-thumbnail"
     [title]="fileName" />

<div class="custom-modal full-screen"
     [ngClass]="{'show-custom-modal': showModal}"
     id="modal-{{id}}">
    <div class="custom-modal-dialog" *ngIf="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" (click)="destroy()">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body p-0"
                 style="min-height: calc(95vh - 70px - 50px)">
                <div class="text-center p-5"
                     *ngIf="globals.mobileAndTabletCheck()">
                    <a href="https://play.google.com/store/apps/details?id=com.pimeomobile.work"
                       target="_blank"
                       rel="noopener noreferrer">
                        <img src="/img/google-play-badge.png" />
                    </a>
                    <p>
                        The markup functionality is not available on the web on
                        mobile, if you need to markup the image please download
                        the PIMeo app from the Play Store
                        <a href="https://play.google.com/store/apps/details?id=com.pimeomobile.work"
                           target="_blank"
                           rel="noopener noreferrer">here</a>, login and then proceed to your entry. If you just
                        need to view the image please select the View button
                        below
                    </p>
                </div>
                <div id="modal-body-{{id}}"></div>
            </div>
            <div class="modal-footer right-margin">
                <div class="btn-group">
                    <button type="button"
                            class="btn btn-warning"
                            (click)="destroy()">
                        Cancel
                    </button>
                    <button type="button"
                            (click)="view($event)"
                            class="btn btn-primary"
                            *ngIf="globals.mobileAndTabletCheck()">
                        View
                    </button>
                    <button type="button"
                            (click)="update($event)"
                            class="btn btn-primary"
                            *ngIf="!globals.mobileAndTabletCheck()">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
